import { render, staticRenderFns } from "./BusinessSecretVer2Section.vue?vue&type=template&id=32673d53&scoped=true&"
import script from "./BusinessSecretVer2Section.vue?vue&type=script&lang=js&"
export * from "./BusinessSecretVer2Section.vue?vue&type=script&lang=js&"
import style0 from "./BusinessSecretVer2Section.vue?vue&type=style&index=0&id=32673d53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32673d53",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
